"use client";

import { usePathname } from "next/navigation";

const ROUTE_LABELS: Record<string, string> = {
  services: "Services",
  "our-work": "Our Work",
  "about-us": "About Us",
  "how-we-work": "How We Work",
  "contact-us": "Contact Us",
  "hire-developer": "Hire Developer",
  "book-a-call": "Book a Call",
  "privacy-policy": "Privacy Policy",
  blog: "Blog",
  "thank-you": "Thank You",
  "hire-dedicated-reactjs-developers": "Hire ReactJS Developers",
  "hire-dedicated-nodejs-developers": "Hire NodeJS Developers",
  "nodejs-development-company-usa": "Node.js Development Company USA",
  "reactjs-development-company-usa": "React.js Development Company USA",
  "hire-dedicated-development-team-usa": "Hire Dedicated Development Team USA",
  "saas-development-company-usa": "SaaS Development Company USA",
  "devops-engineering-services-usa": "DevOps Engineering Services USA",
  avakeen: "Avakeen",
  "beauty-service": "Beauty Service",
  "close-chat": "Close Chat",
  foodbite: "Foodbite",
  helf: "Helf",
  "r-guroo": "R-Guroo",
};

function formatSegment(segment: string): string {
  return ROUTE_LABELS[segment] || segment.replace(/-/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
}

export default function BreadcrumbSchema() {
  const pathname = usePathname();
  if (pathname === "/") return null;

  const segments = pathname.split("/").filter(Boolean);
  const items = [
    { "@type": "ListItem", position: 1, name: "Home", item: "https://techeniac.com/" },
    ...segments.map((segment, i) => ({
      "@type": "ListItem",
      position: i + 2,
      name: formatSegment(segment),
      item: `https://techeniac.com/${segments.slice(0, i + 1).join("/")}`,
    })),
  ];

  const schema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items,
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
    />
  );
}
